webpackJsonp([4],{

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutUs_vue__ = __webpack_require__(1114);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f7c03a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutUs_vue__ = __webpack_require__(1201);
function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f7c03a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_constant_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(73);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["metaInfo"],
  project: __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["PROJECT"],
  data: function data() {
    return {
      project: __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["PROJECT"],
      metaWebsite: __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["METAWEBSITE"],
      metaOrganization: __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["METAORGANIZATION"],
      is_mobile_app: 0
    };
  },

  watch: {
    "$route.query": {
      handler: function handler(newVal, oldVal) {
        var _this = this;

        console.log({ newVal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newVal), oldVal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, oldVal) });
        var is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(function () {
          if (!!is_mobile_app) {
            _this.is_mobile_app = is_mobile_app;
          }
        });
      },

      immediate: true
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["metaInfo"].title = "About us - Cineco | Movie and Event Ticketing Platform in Bahrain";
    __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["metaInfo"].meta[2].content = "Cineco - Your one stop online ticketing platform for movies and events near you in Bahrain";
    __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["metaInfo"].meta[3].content = "About us, cineco";
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(["isRTL"]))
});

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1200);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("0734035b", content, true, {});

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, ".step-container{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.step-container .single-step{padding:10px;width:20%}.step-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.step-wrapper .single-step{text-align:center;padding-left:15px;padding-right:15px;width:20%}@media (max-width:767px){.step-wrapper{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.step-wrapper .single-step{margin-bottom:35px;width:50%}}@media (max-width:576px){.step-wrapper .single-step{width:100%}}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/aboutUs.vue"],"names":[],"mappings":"AACA,gBACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,6BACE,aAAc,AACd,SAAsB,CACvB,AASD,cACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,2BACE,kBAAmB,AACnB,kBAAmB,AACnB,mBAAoB,AACpB,SAAsB,CACvB,AACD,yBACA,cACI,mBAAoB,AAChB,eAAgB,AACpB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,2BACI,mBAAoB,AACpB,SAAsB,CACzB,CACA,AACD,yBACA,2BACI,UAAY,CACf,CACA","file":"aboutUs.vue","sourcesContent":["\n.step-container {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.step-container .single-step {\n  padding: 10px;\n  width: calc(100% / 5);\n}\n\n/* .arrow {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding-top: 180px;\n    justify-content: center;\n  } */\n.step-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.step-wrapper .single-step {\n  text-align: center;\n  padding-left: 15px;\n  padding-right: 15px;\n  width: calc(100% / 5);\n}\n@media (max-width: 767px) {\n.step-wrapper {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.step-wrapper .single-step {\n    margin-bottom: 35px;\n    width: calc(100% / 2);\n}\n}\n@media (max-width: 576px) {\n.step-wrapper .single-step {\n    width: 100%;\n}\n}\n\n/* sdas */\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.is_mobile_app ? '' : 'wrapper'},[(false)?_c('section',{staticClass:"mb-5 pt-3"},[_c('h4',[_vm._v("Hola!")]),_vm._v(" "),_c('p',[_vm._v("\n        Your search for a perfect online movie ticket booking app just got\n        over.\n        "),(_vm.project == 'wanasatime')?_c('span',[_vm._v("MyTiketi- Kenya’s")]):_vm._e(),_vm._v(" "),(_vm.project == 'ticketak')?_c('span',[_vm._v("Ticketak UAE's")]):_vm._e(),_vm._v(" first online\n        movie ticket aggregator Platform is now available on the web & app\n        stores.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We are going to change the way you book your movie tickets online.\n        It’s going to be as simple as App- Tap- Book.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Surf through multiple movies & cinemas near you and book your movie\n        tickets on the go!\n      ")]),_vm._v(" "),_c('h4',{staticClass:"text-center mb-4 mt-3"},[_vm._v("\n        How to book a movie ticket on\n        "),(_vm.project == 'wanasatime')?_c('span',[_vm._v("MyTiketi")]):_vm._e(),_vm._v(" "),(_vm.project == 'ticketak')?_c('span',[_vm._v("Ticketak")]):_vm._e(),_vm._v("?\n      ")]),_vm._v(" "),_c('div',{staticClass:"step-wrapper"},[_c('div',{staticClass:"single-step"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/step-1-new.jpg"),"alt":""}}):_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/trailer.jpg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 mt-2"},[_vm._v("Watch Movie Trailers")])]),_vm._v(" "),_c('div',{staticClass:"single-step"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/step-5.jpeg"),"alt":""}}):_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/Cinemas.jpg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 mt-2"},[_vm._v("Check Cinemas Near You")])]),_vm._v(" "),_c('div',{staticClass:"single-step"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/step-4.jpeg"),"alt":""}}):_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/showtime.jpg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 mt-2"},[_vm._v("Check Show Timings")])]),_vm._v(" "),_c('div',{staticClass:"single-step"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/step-3.jpeg"),"alt":""}}):_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/Seat_Layout.jpg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 mt-2"},[_vm._v("Choose Your Seats")])]),_vm._v(" "),_c('div',{staticClass:"single-step"},[(_vm.project == 'ticketak')?_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/step-2.jpeg"),"alt":""}}):_c('img',{staticClass:"w-75 border rounded",attrs:{"src":require("@/assets/img/about/Booking_Summary.jpg"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 mt-2"},[_vm._v("& Book Movie Tickets!")])])])]):_vm._e(),_vm._v(" "),(false)?_c('section',[_c('h4',{staticClass:"text-center"},[_vm._v("\n        Why use\n        "),(_vm.project == 'wanasatime')?_c('span',[_vm._v("MyTiketi")]):_vm._e(),_vm._v(" "),(_vm.project == 'ticketak')?_c('span',[_vm._v("Ticketak")]):_vm._e(),_vm._v("?\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3 text-center"},[_c('p',[_vm._v("\n            online movie ticket aggregator in The\n            "),(_vm.project == 'wanasatime')?_c('span',[_vm._v("Kenya")]):_vm._e(),_vm._v(" "),(_vm.project == 'ticketak')?_c('span',[_vm._v("UAE")]):_vm._e()])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"row back_white mb-3",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('h3',{staticClass:"static_title"},[_vm._v(_vm._s(_vm.$t("ABOUT")))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t("WANASATIME_ENTERTAINMENT")))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"mb-2"},[_vm._v("\n          "+_vm._s(_vm.$t("SCREENS_PARTNERS"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-md-12 col-lg-6 col-sm-12 col-xs-12 acheivments_info"},[_c('span',{staticClass:"title_no"},[_vm._v("12+")]),_vm._v(" "),_c('h6',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t("YEARS_IN_TICKETING")))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-md-12 col-lg-6 col-sm-12 col-xs-12 acheivments_info"},[_c('span',{staticClass:"title_no"},[_vm._v("15+")]),_vm._v(" "),_c('h6',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t("YEARS_OF_GCC_PRESENCE")))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-md-12 col-lg-6 col-sm-12 col-xs-12 acheivments_info"},[_c('span',{staticClass:"title_no"},[_vm._v("5+")]),_vm._v(" "),_c('h6',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t("MILLION_TICKETS_SOLD")))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex justify-content-center mt-5"},[_c('h3',{staticClass:"static_title_next"},[_vm._v(_vm._s(_vm.$t("HOW_WANASATIME_WORKS")))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',[_vm._v(_vm._s(_vm.$t("WANASATIME_TRANSACTION_M-TICKETS"))+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1202)}}),_vm._v(" "),_c('div',{staticClass:"d-block",class:_vm.isRTL ? 'mr-3' : ' ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("FREE_RESGIDTRATION")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("EVENT_PLANNER")))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1203)}}),_vm._v(" "),_c('div',{staticClass:"d-block",class:_vm.isRTL ? 'mr-3' : 'ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("MULTIPLE_USER-ACCESS")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("PROVIDES_ACCESS")))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1204)}}),_vm._v(" "),_c('div',{staticClass:"d-block",class:_vm.isRTL ? 'mr-3' : 'ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("RESERVED_SEATING")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("ATTENDEES_EVENT_SEATS")))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-none",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1205)}}),_vm._v(" "),_c('div',{staticClass:"d-block",class:_vm.isRTL ? 'mr-3' : ' ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("IVITES_REMINDERS")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("SEND_RECEIVE")))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-none",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1206)}}),_vm._v(" "),_c('div',{staticClass:"d-block",class:_vm.isRTL ? 'mr-3' : ' ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("CUSTOM_EVENT")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("HOST_CAN_CREATE")))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-none",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1207)}}),_vm._v(" "),_c('div',{staticClass:"d-block ",class:_vm.isRTL ? 'mr-3' : ' ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("PERSONALIZE_EVENT")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("CUSTOMIZE_EVENT")))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex",class:_vm.isRTL ? 'center_md' : ''},[_c('img',{staticClass:"about_img",attrs:{"src":__webpack_require__(1208)}}),_vm._v(" "),_c('div',{staticClass:"d-block",class:_vm.isRTL ? 'mr-3' : ' ml-3'},[_c('h4',[_vm._v(_vm._s(_vm.$t("REPARTING_DASHBOARD")))]),_vm._v(" "),_c('span',{staticClass:"about_des"},[_vm._v(_vm._s(_vm.$t("ACCESS_DETAILED")))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-3 text-center"},[_c('p',[_vm._v("Browse through multiple cinemas at once")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-3 text-center"},[_c('p',[_vm._v("Real-time seat selection")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-3 text-center"},[_c('p',[_vm._v("Booking movie tickets on the go")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab1.0eaeae9.png";

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab2.8367c64.png";

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab3.030f11f.png";

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab4.c2b2a11.png";

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab5.3e9b0b0.png";

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab6.282b4dd.png";

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ab7.8336561.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.cf5111d00e64f49aee01.js